import {riskKeys, assertionsValues} from './constants';

import {currentResource} from './../../../../../util/utils';
import {inherentRiskTypes} from './../../../../../util/uiconstants';

const exportToExcelLabels = currentResource.exportToExcelLabels;
const riskDesignationsLabels = currentResource.riskDesignationsLabels;

export const getColumnsToExportRisk = (labels) => [
	{header: labels.reconciliationExport.status, key: riskKeys.status},
	{header: labels.reconciliationExport.primaryTeamRiskName, key: riskKeys.primaryTeamRiskName},
	{header: labels.reconciliationExport.componentTeamRiskName, key: riskKeys.componentTeamRiskName},
	{header: labels.reconciliationExport.riskDesignation, key: riskKeys.riskDesignation},
	{header: labels.reconciliationExport.accountsRelatedToRisk, key: riskKeys.accountsRelatedToRisk},
	{header: labels.reconciliationExport.c, key: riskKeys.c},
	{header: labels.reconciliationExport.eo, key: riskKeys.eo},
	{header: labels.reconciliationExport.mv, key: riskKeys.mv},
	{header: labels.reconciliationExport.ro, key: riskKeys.ro},
	{header: labels.reconciliationExport.pd, key: riskKeys.pd},
	{header: labels.reconciliationExport.comment, key: riskKeys.comment}
];

export const getDataToExportRisk = (data, componentRisks) => {
	let dataToExport = [];
	data?.forEach((risk) => dataToExport.push(createDataObject(risk, true, componentRisks)));
	return dataToExport;
};

const createDataObject = (risk, isPrimary, componentRisks) => {
	const accountsRelatedToRisk = processAdditionalAccounts(risk, isPrimary, componentRisks);
	const account = risk?.accounts?.[0];

	return createRiskItemToExport(risk, isPrimary, account, accountsRelatedToRisk, componentRisks);
};

const processAdditionalAccounts = (risk, isPrimary, componentRisks) => {
	if (risk?.accounts?.length > 1) {
		return risk.accounts
			.slice(1)
			.map((additionalAccount) => createRiskItemToExport(risk, isPrimary, additionalAccount, [], componentRisks));
	}
	return [];
};

const createRiskItemToExport = (risk, isPrimary, account, accountsRelatedToRisk, componentRisks) => {
	return {
		status: exportToExcelLabels.groupRiskStatusLabels[risk.groupRiskStatusId],
		primaryTeamRiskName: isPrimary ? risk.riskName : '',
		componentTeamRiskName: isPrimary ? '' : risk.riskName,
		riskDesignation: riskDesignationsLabels[risk.riskTypeId] || '-',
		accountsRelatedToRisk: account?.accountName || '-',
		c: getInherentRiskValue(account?.assertions, assertionsValues.c),
		eo: getInherentRiskValue(account?.assertions, assertionsValues.eo),
		mv: getInherentRiskValue(account?.assertions, assertionsValues.mv),
		ro: getInherentRiskValue(account?.assertions, assertionsValues.ro),
		pd: getInherentRiskValue(account?.assertions, assertionsValues.pd),
		comment: risk.rationale,
		listOfAccountsRelated: accountsRelatedToRisk?.length > 0 ? accountsRelatedToRisk : [],
		listOfComponentRelatedToPrimary:
			risk?.relatedPrimaryRisks?.length > 0 ? processComponentRisk(risk.relatedPrimaryRisks, componentRisks) : []
	};
};

const getInherentRiskValue = (assertions, abbreviation) => {
	const assertion = assertions?.find((a) => a.assertionAbbreviation === abbreviation);

	if (assertion && inherentRiskTypes[assertion.inherentRiskTypeId]) {
		return inherentRiskTypes[assertion.inherentRiskTypeId];
	}

	return '-';
};

const processComponentRisk = (relatedPrimaryRisks, componentRisks) => {
	return relatedPrimaryRisks
		.map((relatedPrimaryRisk) => {
			const componentRisk = componentRisks?.find((risk) => risk.riskId === relatedPrimaryRisk.componentRiskId);
			if (!componentRisk) return undefined;

			const accountsRelatedToRisk = processAdditionalAccounts(componentRisk, false, componentRisks);
			const account = componentRisk?.accounts?.[0];

			return createRiskItemToExport(componentRisk, false, account, accountsRelatedToRisk, componentRisks);
		})
		.filter(Boolean);
};
